import { createFileRoute } from '@tanstack/react-router';
import { FinanceSettingsLayout } from '@/components/finance/FinanceSettingsLayout';

/**
 * FSU shell unification: parent route for the Settings sub-nav. Wraps the
 * Outlet in `FinanceSettingsLayout` so the four sub-tabs (Setup / Sources /
 * Contacts / Audit log) render with a consistent header. Pre-FSU these were
 * the secondary nav row; collapsing under Settings frees primary-nav space.
 */
export const Route = createFileRoute('/admin/finance/settings')({
  component: FinanceSettingsLayout,
});
